<title mat-dialog-title>MOU Conditions</title>
<mat-dialog-content (scroll)="onScroll($event)">
  <ng-template [ngIf]="mouThemplate">
    <div [innerHTML]="mouThemplate"></div>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [disabled]="buttonDisabled" color="success" (click)="aceptedMou()">
    I agree
  </button>
  <button mat-button color="danger" (click)="close()">close</button>
  <span class="small-text"> By clicking "I agree" you agree to the MOU Conditions </span>
</mat-dialog-actions>
